import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import LoadingSpinner from '../loadingSpinner/';
import { getQueryVariable } from '../../common';
import Message from '../message';
import Keyboard from '../keyboard/keyboardInput';

@withRouter
@inject('accountStore', 'dictStore', 'appStore')
@observer
export default class Login extends Component{

  componentDidMount() {
    this.props.accountStore.logout(1);
    // if (this.props.accountStore.access) {
    //   this.props.history.goBack();
    // }
    this.props.accountStore.setCardId(getQueryVariable('card_id'));
    this.props.appStore.toggleShowTopMenu(false);
    document.getElementById('password-card').focus();
  }

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.props.accountStore.auth.cardID.toString().length < 0 ) {
      this.props.accountStore.setAuthError('Нет карты');
      return false;
    } 
    else if (this.props.accountStore.auth.password.toString().length < 4 ) {
      this.props.accountStore.setAuthError('Длина пароля должна содержать не менее 4 символов');
      document.getElementById('password-card').focus();
      return false;
    }
    this.props.accountStore.cardLogin();
  }

  handleChange = (e) => {
    this.props.accountStore.inputAuth(e, 'password');
  }

  componentWillUnmount(){
    this.props.accountStore.closeForm();
    this.props.appStore.toggleShowTopMenu(true);
  }

  handleCloseMessage = () => {
    this.props.accountStore.clearAuthError();
  }

  render() {
    const {cardId, statusdAuthForm, auth} = this.props.accountStore;
    const {getLang} = this.props.dictStore;
    return(
      <Fragment>
        <h1>{getLang('ENTRANCE')}</h1>
        <div className="login-form-card">
          <form onSubmit={this.handleSubmit}>
            <div className="row clearfix">
              <div className="input-group">
                <Keyboard
                  type="password"
                  name="password"
                  className="form-control login-form-card__pass"
                  pattern="[0-9]{0,6}"
                  maxLength="6"
                  placeholder="Пароль"
                  tabIndex="0"
                  id="password-card"
                  value={auth.password}
                  onChange={this.handleChange }
                  disabled={statusdAuthForm.disabled}
                  positionX="right"
                  positionY="bottom"
                  forceShowIcon
                />
                <span className="input-group-addon login-form_attemp"  title="Количество попыток">
                  {statusdAuthForm.attempts}
                </span>
              </div>
            </div>
            <div className="login-form-button-wrp">
              <button 
                className={`flat_button login-form_login ${statusdAuthForm.wait ? 'wait' : ''}`} 
                tabIndex="4" 
                disabled={statusdAuthForm.wait}
              >ВОЙТИ</button>
            </div>
            {statusdAuthForm.status ? <Message text={statusdAuthForm.text} onClose={this.handleCloseMessage} /> : ''}
          </form>
        </div>
      </Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/login/index.js